export enum ContentSectionThemes {
  WHITE = 'Wit',
  LIGHT = 'Licht',
  BRAND = 'Merk',
  DARK = 'Donker',
}

export type ContentSectionTheme =
  | ContentSectionThemes.WHITE
  | ContentSectionThemes.LIGHT
  | ContentSectionThemes.BRAND
  | ContentSectionThemes.DARK
  | undefined;
